module.exports = __webpack_public_path__ + "img/activity.834f065b.jpg";